exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".w-imbee-container[data-v-5a923dd5]{position:absolute;right:0;bottom:80px;height:100%;width:100%;border-radius:12px;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;flex-direction:column;box-shadow:0 20px 60px 0 hsla(0,0%,47%,.2),0 0 25px 10px hsla(0,0%,71%,.15);overflow:hidden}@media screen and (max-width:568px){.w-imbee-container[data-v-5a923dd5]{border-radius:0;bottom:0!important;left:auto!important;max-height:100%!important;height:100%!important;right:0!important;top:auto!important;width:100%!important;max-width:100%!important;overflow:hidden!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-5a923dd5","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Container.vue
// module id = 182
// module chunks = 0 1